const urlEncode = (key, value) => {
    var q = new URLSearchParams();
    q.set(key, value);
    return q.toString()
}

export default urlEncode